import RawRenderingService from './raw_rendering_service';
import {RenderingServices} from '../types';

/**
 * Returns raw DOM element version of react-router Link component.
 * @param params
 * @param services
 * @returns {Element}
 */
export default function reactRouterLinkRenderer(
  params,
  services: RenderingServices = {}
) {
  const {children, tabIndex, title, to} = params;
  const {navigate} = services;

  const elem = document.createElement('a');
  elem.setAttribute('href', to);
  elem.setAttribute('title', title);
  elem.setAttribute('tabIndex', tabIndex);
  elem.onclick = (e) => {
    if (navigate) {
      e.preventDefault();
      navigate(to);
    }
    return false;
  };
  RawRenderingService.appendChildNodeOrHtml(elem, children);

  return elem;
}
